<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-12 10:54:54
-->
<template>
  <!-- 养成 -->
  <div class="content-wrap">
      <div class="page-list">
        <div class="page-type-switch">
          <div
            :class="pageType === 'seedling' ? 'type-activite' : ''"
            @click="pageType = 'seedling'"
          >
            投苗情况
          </div>
          <div
            :class="pageType === 'pond' ? 'type-activite' : ''"
            @click="pageType = 'pond'"
          >
            排塘情况
          </div>
        </div>
        <!-- 投苗情况 -->
        <SeedlingPage v-if="pageType === 'seedling'" />
        <!-- 排塘情况 -->
        <PondPage v-if="pageType === 'pond'" />
      </div>
  </div>
</template>

<script>
import SeedlingPage from "./yc-put-seedling.vue";
import PondPage from "./yc-put-pond.vue";
export default {
  name: "yc",
  data() {
    return {
      pageType: "seedling",
    };
  },
  computed: {},
  methods: {},
  components: {
    SeedlingPage,
    PondPage,
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {},
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
</style>